import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
export function AskAI() {
  const [query, setQuery] = useState('');
  const [isFocused, setIsFocused] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      alert(`AI Query: ${query}`);
      setQuery('');
    }
  };
  return <form onSubmit={handleSubmit} className={`flex items-center gap-3 bg-white rounded-xl p-2.5 border transition-all duration-200 mb-6 soft-shadow ${isFocused ? 'border-accent ring-1 ring-accent/20' : 'border-gray-200 hover:border-gray-300'}`} style={isFocused ? {
    borderColor: 'var(--accent-color)',
    boxShadow: '0 0 0 1px color-mix(in srgb, var(--accent-color) 20%, transparent)'
  } : {}} data-id="element-45">
      <div className="flex-shrink-0 relative" data-id="element-46">
        <img src="https://cdn.magicpatterns.com/uploads/hnpUC8Q1cWWW3fAJNQG61U/houseful-icon.jpg" alt="Houseful AI Assistant" className="w-8 h-8 rounded-lg object-cover" data-id="element-47" />
      </div>

      <input type="text" value={query} onChange={e => setQuery(e.target.value)} onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)} placeholder="How can I help you Today, An?" className="flex-1 bg-transparent border-none outline-none text-sm text-gray-900 placeholder-gray-400 min-w-0" aria-label="Ask AI assistant" data-id="element-48" />

      <button type="submit" disabled={!query.trim()} className={`flex-shrink-0 p-2 rounded-lg transition-colors flex items-center justify-center ${query.trim() ? 'bg-accent text-white hover:opacity-90' : 'bg-gray-100 text-gray-400 cursor-not-allowed'}`} style={query.trim() ? {
      backgroundColor: 'var(--accent-color)'
    } : {}} aria-label="Send query" data-id="element-49">
        <ArrowRight className="w-4 h-4" data-id="element-50" />
      </button>
    </form>;
}